



































import { Component, Vue } from 'vue-property-decorator';
import { apiClient } from '@/api/ApiClient';
import countryList from 'country-list';
import camelcase from 'camelcase';
import moment from 'moment';

@Component({
  components: {

  },
})
export default class extends Vue {

  public get countryList() {
    return countryList;
  }

  public get moment() {
    return moment;
  }

  // table filter
  public range: Date[] = [];
  public phone = '';
  public countryCode: string = null;
  public orderByColumn: string = null;
  public orderByOrder: string = null;

  // table
  public isTableLoading = false;

  public pageSize = 100;
  public total = 0;
  public currentPage = 1;

  public data: any[] = [];

  // filter data
  public countryCodes: any[] = [];
  public get selectCountryCodeByName() {
    return this.countryCodes.map(value => ({
      label: countryList.getName(value),
      value,
    }));
  }

  public mounted() {
    this.loadData();
  }

  // table events
  public async onPaginationChange() {
    await this.loadPhones();
    this.$scrollTo("#data-table");
  }

  // sort
  public async tableSortChange({ column, prop, order }) {
    if (prop && order) {
      this.orderByColumn = camelcase(prop.replace('.', '_'));
      this.orderByOrder = order.startsWith("asc") ? "ASC" : 'DESC';
    } else {
      this.orderByOrder = this.orderByColumn = null;
    }
    return this.loadPhones();
  }

  //
  private async loadData() {
    await Promise.all([
      this.loadPhones(),
      this.loadPhoneCountryCodes(),
    ]);
  }
  private async loadPhones() {
    this.isTableLoading = true;

    const { data } = await apiClient.phones(this.getFilter());

    this.total = data.count;
    this.data = data.data;
    this.isTableLoading = false;
  }

  private async loadPhoneCountryCodes() {
    const { data } = await apiClient.phonesCountryCodes();
    this.countryCodes = data;
  }

  private getFilter() {
    const range = this.range || [];

    return {
      take: this.pageSize,
      page: this.currentPage,

      orderByColumn: this.orderByColumn,
      orderByOrder: this.orderByOrder,

      phone: this.phone,
      countryCode: this.countryCode ? this.countryCode : null,

      from: range[0],
      to: range[1],
    };
  }

}
